import React from "react";
import logger from "logger";
import moment from "moment-timezone";
import Tooltip from "@material-ui/core/Tooltip";
import { getHumanReadableTimePassedSinceThisInstance } from "Utils/Common";
import { StringValue } from "TaskHistory/Tasklet/Tasklets/StringValue";

const tz = moment.tz.guess();
const currDate = moment(new Date());
export default function(props) {
  const { task } = props;
  let taskCreationDisplayDate = "-";
  let timeString = {};

  if (task.taskcreation) {
    const taskMoment = moment.unix(task.taskcreation / 1000);
    taskCreationDisplayDate = `${taskMoment.format(
      "dddd MMMM Do YYYY, h:mm:ss a"
    )} ${tz}`;
    timeString = getHumanReadableTimePassedSinceThisInstance(task.taskcreation);
  }
  return (
    <>
      {task.taskcreation && (
        <>
          <div className="infokey">Created</div>
          <div className="infovalue" style={{ fontSize: "15px" }}>
            <Tooltip title={timeString.timeString}>
              <span>{taskCreationDisplayDate}</span>
            </Tooltip>
          </div>
        </>
      )}
      <StringValue label={"Status"} value={task.taskstatus} />
    </>
  );
}
